import * as React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { AlertType, DefaultIntervalValue, DefaultIsAlertAllowed } from '../../../../reducers/alert';

export const useChangeAlertInterval = () => {
    const storedInterval = useSelector((state) => get(state, 'alert.interval', DefaultIntervalValue));
    const storedAllowed = useSelector((state) => get(state, 'alert.allowed', DefaultIsAlertAllowed));
    const [allowed, changeAllowed] = React.useState(storedAllowed);
    const [interval, changeInterval] = React.useState(storedInterval);

    const handleIntervalChange = React.useCallback((update) => {
        changeInterval((prevState) => ({ ...prevState, ...update }));
    }, []);

    const handleAllwedChange = React.useCallback(
        (toggledTimer) =>
            changeAllowed((prevState) => ({
                ...prevState,
                [toggledTimer]: !prevState[toggledTimer],
            })),
        []
    );

    React.useEffect(() => {
        if (!allowed[AlertType.ALTITUDE]) {
            changeInterval((prevState) => ({
                ...prevState,
                [AlertType.ALTITUDE]: DefaultIntervalValue[AlertType.ALTITUDE],
            }));
        }
        if (!allowed[AlertType.FUEL]) {
            changeInterval((prevState) => ({ ...prevState, [AlertType.FUEL]: DefaultIntervalValue[AlertType.FUEL] }));
        }
    }, [allowed]);

    return {
        allowed,
        interval,
        allowedChangeHandler: handleAllwedChange,
        intervalChangeHandler: handleIntervalChange,
    };
};
